import {
  Asset,
  cacheKeys,
  Media,
  useUpdateMutation,
} from '@gripp/shared-logic';
import { CustomAlert } from '@gripp/shared-ui';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type DeleteAssetFileModalProps = {
  visible: boolean;
  hide: () => void;
  media: Media;
  asset: Asset;
  onDelete: () => void;
};

export const DeleteAssetFileModal = (props: DeleteAssetFileModalProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync: updateAsset } = useUpdateMutation({
    modelName: 'asset',
    query: UPDATE_ASSET,
  });

  const doDelete = async () => {
    const fileList =
      props.asset.media
        ?.filter((file) => file.id !== props.media.id)
        .map((f) => ({ id: f.id })) || [];

    const input = {
      id: props.asset.id,
      media: fileList,
    };
    await updateAsset(
      { input },
      {
        onSuccess: async () => {
          const cacheKey = cacheKeys('asset').all;
          await queryClient.invalidateQueries({ queryKey: cacheKey });
          props.hide();
          props.onDelete();
        },
      }
    );
  };

  return (
    <CustomAlert
      visible={props.visible}
      hideAlert={props.hide}
      action={doDelete}
      title={t('asset.detail.confirmDelete', { fileName: props.media.name })}
      primaryButtonLabel={t('topNav.customAlert.yes')}
      secondaryButtonLabel={t('topNav.customAlert.cancel')}
    />
  );
};

const UPDATE_ASSET = `
  mutation Mutation($input: MutateAssetInput!) {
  updateAsset(input: $input) {
    id
  }
}
`;
